import { request } from './apiClient';

// Monta a query string a partir de um objeto de filtros, ignorando valores vazios.
function buildQuery(params) {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    if (Array.isArray(value)) {
      if (value.length === 0) return;
      search.set(key, value.join(','));
      return;
    }
    search.set(key, value);
  });
  const qs = search.toString();
  return qs ? `?${qs}` : '';
}

// Medição de moldagem no período (data de concretagem): resumo dia a dia + CPs em ordem de data.
// Retorna { resumo: { totalCaminhoes, totalCps, cpsSabado, cpsDomingo, porDia[] }, cps[] }.
export const getMedicaoMoldagem = async ({ dataInicio, dataFim, idObras, idEmpresas } = {}) => {
  const qs = buildQuery({ dataInicio, dataFim, idObras, idEmpresas });
  return await request(`/api/medicao/moldagem${qs}`);
};

// Medição de ruptura no período (rompimento real ou ruptura prevista): resumo por Fck/idade + CPs.
// Retorna { resumo: { total, rompidos, previstos, porFck[], porIdade[] }, cps[] }, com fcj (MPa) já calculado.
export const getMedicaoRuptura = async ({ dataInicio, dataFim, idObras, idEmpresas } = {}) => {
  const qs = buildQuery({ dataInicio, dataFim, idObras, idEmpresas });
  return await request(`/api/medicao/ruptura${qs}`);
};
